(async () => {
    window.v = new URL(import.meta.url).searchParams.get('v') || Date.now();
    await import(`./edm-modal.js?v=${v}`);
    await import(`./edm-popover.js?v=${v}`);
    await import(`./edm-slider.js?v=${v}`);
    await import(`./edm-quantity.js?v=${v}`);
    await import(`./edm-load-section.js?v=${v}`);
    await import(`./edm-cart.js?v=${v}`);
    await import(`./edm-teams.js?v=${v}`);

    // Handle interest form submission
    const url = new URL(location.href);
    if (
        url.searchParams.get('contact_posted') === 'true' &&
        location.hash.startsWith('#interested-')
    ) {
        const dialog = document.querySelector(location.hash).nextElementSibling;
        if (dialog instanceof HTMLDialogElement) {
            dialog.showModal();
            dialog.addEventListener('toggle', () => {
                if (!dialog.open) {
                    history.replaceState({}, '', location.pathname);
                }
            });
        }
    }

    document.addEventListener('change', (event) => {
        const select = event.target.closest(
            '.product-modal-view-variant-select',
        );
        if (!select) return;

        const option = select.selectedOptions[0];
        const view = select.closest('.product-modal-view');
        if (!option || !view) return;

        const price = view.querySelector('[data-variant-price]');
        if (price) price.textContent = option.dataset.price || '';

        const heading = view.querySelector('[data-product-title]');
        if (heading && option.dataset.title) {
            heading.textContent = `${heading.dataset.productTitle} - ${option.dataset.title}`;
        }

        const image = view.querySelector('.product-modal-view-gallery-img img');
        if (image && option.dataset.image) {
            image.src = option.dataset.image;
            image.removeAttribute('srcset');
        }

        const idInput = view.querySelector('input[name="id"]');
        if (idInput) idInput.value = option.value;
    });

    document.addEventListener('click', (event) => {
        if (
            event.target.classList.contains(
                'product-modal-view-gallery-thumbnail',
            )
        ) {
            const mainImage = document.querySelector(
                '.product-modal-view-gallery-img img',
            );
            const thumbnail = event.target;
            if (mainImage) {
                mainImage.src = thumbnail.dataset.src;
                mainImage.srcset = thumbnail.dataset.srcset;
            }
        }
    });

    const driver = window.driver.js.driver;

    if (document.querySelector('.show-bubbles')) {
        const driverObj = driver({
            popoverClass: 'custom-popover',
            overlayColor: 'rgba(153, 153, 153, 0.6)',
            allowClose: false,
            showProgress: false,
            smoothScroll: true,
            overlayClickBehavior: 'nextStep',
            popoverOffset: 20,
            showButtons: ['next', 'close'],
            doneBtnText: 'Finish',
            animate: false,
            stageRadius: 0,
            stagePadding: 5,
            onDestroyed: () => {
                document.dispatchEvent(
                    new Event('tour-completed', { bubbles: false }),
                );
            },
            steps: [
                {
                    element: '.navbar-desktop a[href="/collections"]',
                    popover: {
                        side: 'left',
                        align: 'start',
                    },
                },
                {
                    element: '#bubbles-account-link',
                    popover: {
                        side: 'bottom',
                        align: 'center',
                    },
                },
                {
                    element: '#bubbles-credit-link',
                    popover: {
                        side: 'right',
                        align: 'center',
                    },
                },
                {
                    element: '#bubbles-tier-title-link',
                    popover: {
                        side: 'right',
                        align: 'center',
                    },
                },
                {
                    element: '#bubbles-tier-upgrade-link',
                    popover: {
                        side: 'bottom',
                        align: 'center',
                    },
                },
                {
                    element: '#bubbles-range-title-link',
                    popover: {
                        side: 'right',
                        align: 'center',
                    },
                },
            ].map((step, index) => {
                try {
                    const data = window.tooltipData[index];
                    return {
                        ...step,
                        popover: {
                            ...step.popover,
                            description: data.body,
                            title: data.title,
                        },
                    };
                } catch (e) {
                    return step;
                }
            }),
        });

        driverObj.drive();
    }
})();
